<template>
    <runtime-template-compiler :template="template" />
</template>

<script>

import grccms_megamenu from '../GrcComponents/grccms_megamenu.vue'
import grccms_topmenu from '../GrcComponents/grccms_topmenu.vue'
import grccms_slider from '../GrcComponents/grccms_slider.vue'
import grccms_bloglist from '../GrcComponents/grccms_bloglist.vue'
import grccms_counter from '../GrcComponents/grccms_counter.vue'
import grccms_accordion from '../GrcComponents/grccms_accordion.vue'
import GrcText from '../GrcComponents/GrcText.vue'

import frmteszt from '../frmTeszt/frmteszt.vue'

import frmlogin from '../frmlogin/frmlogin.vue'

import frmteszt_accountdata from '../frmteszt_accountdata/frmteszt_accountdata.vue'


import frmszolgkeres from '../frmszolgkeres/frmszolgkeres.vue'

export default {
  name: 'GrcCMSRENDER',
  components: {
    grccms_megamenu,
    grccms_topmenu,
    grccms_slider,
    grccms_bloglist,
    grccms_counter,
    grccms_accordion,
    GrcText,

    frmteszt,
    frmlogin,
    frmteszt_accountdata,
    frmszolgkeres
    
  },
  props: {
  },
  data () {
      return {
        template: "",
      }
  },
  model: {
  },  
  methods:{


  },
  created()
  {
    //console.log("create: "+Date.now());
      this.template = gPageContent;
  },

  mounted()
  {
    this.$emit("render_mounted");
  }

}


</script>


<style scoped>


</style>